import { useAuth } from "./useAuth";

export default function useAdmin() {
  const { user } = useAuth();
  return user && user.isAdmin;
}
